import React from 'react';
import { Row, Col } from 'react-onsenui';
import { isLiveScorer, extract, getRegularTimeForAction } from '../../../../../helpers';
import _ from 'lodash';
import Action from '../action/Action'
import { v4 as uuid4 } from 'uuid';
import './ListAction.css';
import PropTypes from 'prop-types';

const ListActions = (props) => {
    if( !_.isEmpty(props.live) && !props.live.ended && _.isEmpty(props.live.actions)) {
        return (
            <div className='start'>
                <Row>
                    <Col>
                        <div className="txt center-align">
                            {props.pageReducer === 'pastMatch' ? 'Aucune action ont été déclarées pour ce live' : (isLiveScorer([props.live]) ? 'Appuie sur le + pour démarrer ton live' : 'Rendez-vous le jour du match pour suivre en direct la confrontation entre ces 2 équipes')}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
    else if(!_.isEmpty(props.live.actions)) {
        const orderedActions = _.orderBy(props.live.actions, a => a.data.label === 'debut' ? -1 : _.toNumber(getRegularTimeForAction(props.live.actions, a)) * _.toNumber(extract(a['@id'], '/', 3)), 'desc');
        const tab = _.filter(props.live.actions, action => action.data.label === 'tab');
        return  _.map(orderedActions, (action,key) => {
            return <Action stopInterval={props.stopInterval} startInterval={props.startInterval} key={uuid4()} action={action} live={props.live} allTab={tab} />
        })
    }
    else {
        return <div></div>
    }
}

ListActions.propTypes = {
    live: PropTypes.object.isRequired,
    pageReducer: PropTypes.string.isRequired,
    startInterval: PropTypes.func,
    stopInterval: PropTypes.func
}

export default ListActions;